// extracted by mini-css-extract-plugin
export default {"box":"FileUploader_box__nr+wp","btn":"FileUploader_btn__5Y0gi","error":"FileUploader_error__pksoQ"};